const initialState = () => ({
    theme: 'light_1',
    menuIsOpen: false,
    themeSelectorIsOpen: false,
})

export default initialState
